import { Routes } from '@angular/router';
import { EcommerceComponent } from './pages/dashboard/ecommerce/ecommerce.component';
import { NotFoundComponent } from './pages/other-page/not-found/not-found.component';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { SignInComponent } from './pages/auth-pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/auth-pages/sign-up/sign-up.component';
import { AuthGuard } from './security/auth.guard';
import { GuestGuard } from './security/guest.guard';
import { SuperAdminGuard } from './security/super-admin.guard';
import { ClientsComponent } from './pages/clients/clients.component';
import { ProductComponent } from './pages/product/product.component';
import { ServiceComponent } from './pages/services/service.component';
import { SaleComponent } from './pages/sales/sale.component';
import { CreditDebitNoteComponent } from './pages/credit-debit-notes/credit-debit-note.component';
import { RemissionGuideComponent } from './pages/remission-guides/remission-guide.component';
import { SunatDocumentsComponent } from './pages/sunat-documents/sunat-documents.component';
import { SalesReportComponent } from './pages/reports/sales-report/sales-report.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { CarrierComponent } from './pages/carriers/carrier.component';
import { DriverComponent } from './pages/drivers/driver.component';
import { MenusComponent } from './pages/security/menus/menus.component';
import { ProfilesComponent } from './pages/security/profiles/profiles.component';
import { SecurityUsersComponent } from './pages/security/users/security-users.component';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import { CompaniesComponent } from './pages/companies/companies.component';
import { CategoriesComponent } from './pages/inventory/categories/categories.component';
import { ServiceCategoriesComponent } from './pages/inventory/service-categories/service-categories.component';
import { SeriesComponent } from './pages/general/series/series.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: EcommerceComponent,
        pathMatch: 'full',
        title: 'Inicio | Multi-Empresa',
      },
      {
        path: 'clients',
        component: ClientsComponent,
        title: 'Clientes | Multi-Empresa'
      },
      {
        path: 'products',
        component: ProductComponent,
        title: 'Productos | Multi-Empresa'
      },
      {
        path: 'services',
        component: ServiceComponent,
        title: 'Servicios | Multi-Empresa'
      },
      {
        path: 'sales',
        component: SaleComponent,
        title: 'Ventas | Multi-Empresa'
      },
      {
        path: 'credit-debit-notes',
        component: CreditDebitNoteComponent,
        title: 'Notas de Crédito / Débito | Multi-Empresa'
      },
      {
        path: 'remission-guides',
        component: RemissionGuideComponent,
        title: 'Guías de Remisión | Multi-Empresa'
      },
      {
        path: 'sunat-documents',
        component: SunatDocumentsComponent,
        title: 'Adm. Comprobantes | Multi-Empresa'
      },
      {
        path: 'reports/sales',
        component: SalesReportComponent,
        title: 'Reporte de Ventas | Multi-Empresa'
      },
      {
        path: 'configuration',
        component: ConfigurationComponent,
        title: 'Configuración | Multi-Empresa'
      },
      {
        path: 'carriers',
        component: CarrierComponent,
        title: 'Transportistas | Multi-Empresa'
      },
      {
        path: 'drivers',
        component: DriverComponent,
        title: 'Conductores | Multi-Empresa'
      },
      {
        path: 'security/menus',
        component: MenusComponent,
        title: 'Menús | Multi-Empresa'
      },
      {
        path: 'security/profiles',
        component: ProfilesComponent,
        title: 'Perfiles | Multi-Empresa'
      },
      {
        path: 'security/users',
        component: SecurityUsersComponent,
        title: 'Usuarios | Multi-Empresa'
      },
      {
        path: 'my-profile',
        component: MyProfileComponent,
        title: 'Mi Perfil | Multi-Empresa'
      },
      {
        path: 'companies',
        component: CompaniesComponent,
        canActivate: [SuperAdminGuard],
        title: 'Empresas | Multi-Empresa'
      },
      {
        path: 'categories',
        component: CategoriesComponent,
        title: 'Categorías | Multi-Empresa'
      },
      {
        path: 'service-categories',
        component: ServiceCategoriesComponent,
        title: 'Categorías de Servicio | Multi-Empresa'
      },
      {
        path: 'series',
        component: SeriesComponent,
        title: 'Series | Multi-Empresa'
      },
    ]
  },
  // auth pages
  {
    path: 'signin',
    component: SignInComponent,
    canActivate: [GuestGuard],
    title: 'Iniciar Sesión | Multi-Empresa'
  },
  {
    path: 'signup',
    component: SignUpComponent,
    canActivate: [GuestGuard],
    title: 'Registro | Multi-Empresa'
  },
  // error pages
  {
    path: '**',
    component: NotFoundComponent,
    canActivate: [GuestGuard],
    title: 'Not Found | Multi-Empresa'
  },
];
